import type { Font } from '../types/font';
import { cyrillicExt } from '../types/unicode-range';

export const notoSansV27: Font = {
  fontFamily: 'noto-sans-v27-R0jH9dSR49zPxzoMDuSP6',
  displayName: 'Noto Sans',
  sources: [
    {
      fontStyle: 'italic',
      fontWeight: 'bold',
      unicodeRange: 'cyrillic',
      src: 'noto-sans-v27-greek-700italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'cyrillic',
      src: 'noto-sans-v27-cyrillic-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'bold',
      unicodeRange: 'cyrillic',
      src: 'noto-sans-v27-cyrillic-700italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: cyrillicExt,
      src: 'noto-sans-v27-cyrillic-ext-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'bold',
      unicodeRange: cyrillicExt,
      src: 'noto-sans-v27-cyrillic-ext-700italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'normal',
      unicodeRange: cyrillicExt,
      src: 'noto-sans-v27-cyrillic-ext-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: cyrillicExt,
      src: 'noto-sans-v27-cyrillic-ext-regular.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'normal',
      unicodeRange: 'cyrillic',
      src: 'noto-sans-v27-cyrillic-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'cyrillic',
      src: 'noto-sans-v27-cyrillic-regular.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'devanagari',
      src: 'noto-sans-v27-devanagari-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'bold',
      unicodeRange: 'devanagari',
      src: 'noto-sans-v27-devanagari-700italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'normal',
      unicodeRange: 'devanagari',
      src: 'noto-sans-v27-devanagari-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'devanagari',
      src: 'noto-sans-v27-devanagari-regular.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'greek',
      src: 'noto-sans-v27-greek-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'greekExt',
      src: 'noto-sans-v27-greek-ext-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'bold',
      unicodeRange: 'greekExt',
      src: 'noto-sans-v27-greek-ext-700italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'normal',
      unicodeRange: 'greekExt',
      src: 'noto-sans-v27-greek-ext-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'greekExt',
      src: 'noto-sans-v27-greek-ext-regular.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'normal',
      unicodeRange: 'greek',
      src: 'noto-sans-v27-greek-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'greek',
      src: 'noto-sans-v27-greek-regular.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'latin',
      src: 'noto-sans-v27-latin-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'bold',
      unicodeRange: 'latin',
      src: 'noto-sans-v27-latin-700italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'latinExt',
      src: 'noto-sans-v27-latin-ext-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'bold',
      unicodeRange: 'latinExt',
      src: 'noto-sans-v27-latin-ext-700italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'normal',
      unicodeRange: 'latinExt',
      src: 'noto-sans-v27-latin-ext-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'latinExt',
      src: 'noto-sans-v27-latin-ext-regular.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'normal',
      unicodeRange: 'latin',
      src: 'noto-sans-v27-latin-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'latin',
      src: 'noto-sans-v27-latin-regular.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'vietnamese',
      src: 'noto-sans-v27-vietnamese-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'bold',
      unicodeRange: 'vietnamese',
      src: 'noto-sans-v27-vietnamese-700italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'normal',
      unicodeRange: 'vietnamese',
      src: 'noto-sans-v27-vietnamese-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'vietnamese',
      src: 'noto-sans-v27-vietnamese-regular.woff2',
      format: 'woff2',
    },
  ],
};
